import Loader from "./Loader";

/**
 * Listing / main-column loading: keeps app chrome (sidebar + header) visible and centers the
 * spinner in the main column (filters + table + pagination), not only over the table card.
 *
 * Wrap filters + table (and pagination if present) with `ContentLoader` and pass `loading`.
 *
 * @param {object} props
 * @param {boolean} props.loading
 * @param {import("react").ReactNode} props.children
 * @param {string} [props.className] — on the outer relative wrapper (e.g. min-height for main column)
 * @param {boolean} [props.dimContent=true] — slightly fade content under the overlay while loading
 */
export function ContentLoader({ loading, children, className = "", dimContent = true }) {
  return (
    <div className={`relative w-full min-h-[50vh] ${className}`.trim()}>
      {loading && <Loader variant="content" />}
      <div
        className={
          loading && dimContent
            ? "pointer-events-none select-none opacity-50 transition-opacity"
            : ""
        }
      >
        {children}
      </div>
    </div>
  );
}
